module.exports = __webpack_public_path__ + "img/gov-of-canada.9fceebf3.jpg";